<div class="swipe-hint">
  <div class="swipe-icon">
  	<i class="fa-light fa-arrows-left-right"></i>
  </div>
  <span>{{msg()}}</span>
</div>